import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ChatIcn } from "Assets/Images/icn/Chat.svg";

const ToastNotification = ({ name, message }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/chat");
  };

  return (
    <div
      className="d-flex align-items-center gap-2 w-100"
      onClick={handleClick}
      style={{ cursor: "pointer" }}
    >
      <div
        className="bg-primary d-flex justify-content-center text-white align-items-center"
        style={{
          borderRadius: "50%",
          height: "40px",
          width: "40px",
          fontWeight: "bold",
          padding: "10px",
        }}
      >
        <ChatIcn />
      </div>
      <div>
        <strong className="d-block">{name}</strong>
        <p
          className="mb-0"
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {message}
        </p>
      </div>
    </div>
  );
};

export default ToastNotification;
